import React, { useState } from "react";
import Modal from "../../components/Modal";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";

const UpdateRequisition = ({ modalOpen, setModalOpen, item }) => {
  const { requestWithAuth } = useAuth();
  const [submittingForm, setSubmittingForm] = useState(false);
  const [quantity, setQuantity] = useState(null);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if ( quantity === "") {
      toast.error("Please specify the quantity");
      return;
    }else if(!quantity){
        toast.error("Please specify the quantity");
      return;
    }
    
    Swal.fire({
      icon: "question",
      title: "Are you sure you want to update this supply?",
      showDenyButton: true,
      confirmButtonText: "Yes Proceed!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        
        try {
          setSubmittingForm(true);
          const body = JSON.stringify({
            quantity: quantity,
          });
          
          const data = await requestWithAuth(
            `/inventory/requisition/branch/${item?.id}/item?action=update`,
            "PUT",
            body,
            {
              "Content-Type": "application/json",
            }
          );
          Swal.fire({
            icon: "success",
            title: "Requested!",
            text: "Quantity Updated Successfully",
          }).then(() => {
            window.location.reload();
          });
        } catch (error) {
          toast.error("Something went wrong!");
        } finally {
          setSubmittingForm(false);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <div>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Supply Details"
      >
        <form onSubmit={(e) => handleUpdate(e)}>
          <div className="grid grid-cols-2 gap-5">
            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Drug Name
              </label>
              <input
                type="text"
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                value={item?.drug}
                disabled
              />
            </div>
            

            <div className="flex flex-col gap-2">
              <label htmlFor="" className="font-bold">
                Total Requested
              </label>
              <input
                type="number"
                value={quantity == "" ? quantity : quantity ? quantity : item?.quantity}
                className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                onChange={(e) => setQuantity(e.target.value)}
              />
            </div>

            
          </div>
          <div className="flex items-center justify-end gap-6 mt-7">
            <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
              Close
            </div>
            {submittingForm ? (
              <div className="bg-blue-400 flex items-center gap-2 rounded px-4 py-2 text-white ">
                <RotatingLines strokeColor="white" height="12" width="12" />{" "}
                Submitting
              </div>
            ) : (
              <button className="bg-blue-500 hover:bg-blue-600 rounded px-4 py-2 text-white ">
                Submit Form
              </button>
            )}
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default UpdateRequisition;
